import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getHistory(userId) {
        return axios.get(`${API_URL}/user-cuadrilla-history`, {
            headers: authHeader(),
            params: { user_id: userId }
        });
    },
};
